import AssistantManager from "../components/assistants/AssistantManager";

function Assistants() {
  return <AssistantManager />;
}

export default Assistants;
